const moment = require('moment');

function formatPhoneNumber(value) {
    if (value && value.length >= 10) {
        if (value && value.startsWith("04")) {
            // mask for mobile number
            var a = value.slice(0, 4);
            var b = value.slice(4, 7);
            var c = value.slice(7);

            return `${a} ${b} ${c}`;
        }
    
        // mask for regular numbers

        var a = value.slice(0, 2);
        var b = value.slice(2, 6);
        var c = value.slice(6);

        return `(${a}) ${b} ${c}`;
    }

    return value;
}

/**
 * https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-dollars-currency-string-in-javascript
 */
function formatCurrency(value) {
    if (!value) {
        return "";
    }

    return "$" + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

/**
 * https://stackoverflow.com/questions/8522673/make-a-number-a-percentage#comment18163981_8522704
 */
function formatPercentage(value){
    return (value * 100).toFixed(2) + "%";
}

function formatBSB(value) {
    if (!value) {
        return value;
    }

    return value.slice(0, 3) + "-" + value.slice(3);
}

function formatDate(value) {
    if(!value){
        return;
    }
    
    return moment(value).format("DD/MM/YYYY");
}

export default {
    formatPhoneNumber,
    formatCurrency,
    formatPercentage,
    formatBSB,
    formatDate
}